import { LocalTypes } from '../types/Chatbot';

export default {
    namespaced: true,
    state: {
        isOpen: false,
        chatHistory: false,
        displayChatbot: true,
    },
    getters: {},
    actions: {},
    mutations: {
        [LocalTypes.mutations.OPEN_CHATBOT]: (state) => {
            state.isOpen = true;
        },
        [LocalTypes.mutations.CLOSE_CHATBOT]: (state) => {
            state.isOpen = false;
        },
        [LocalTypes.mutations.TOGGLE_CHATBOT]: (state) => {
            state.isOpen = !state.isOpen;
        },
        [LocalTypes.mutations.NEW_MESSAGE]: (state) => {
            state.chatHistory = true;
        },
        [LocalTypes.mutations.DISPLAY_CHATBOT]: (state, currentLocale) => {
            state.displayChatbot = currentLocale === 'de';
        },
    },
};
